import apiService from './apiService';

export const teamsService = {
  async getTeams(): Promise<any> {
    return apiService.get('/teams');
  },

  async createTeam(teamData: any): Promise<any> {
    return apiService.post('/teams', teamData);
  },

  async getTeamById(id: string): Promise<any> {
    return apiService.get(`/teams/${id}`);
  },

  async updateTeam(id: string, updates: any): Promise<any> {
    return apiService.put(`/teams/${id}`, updates);
  },

  async deleteTeam(id: string): Promise<void> {
    return apiService.delete(`/teams/${id}`);
  },

  async getMembers(teamId: string): Promise<any> {
    return apiService.get(`/teams/${teamId}/members`);
  },

  async addMember(teamId: string, memberData: any): Promise<any> {
    return apiService.post(`/teams/${teamId}/members`, memberData);
  },

  async removeMember(teamId: string, userId: string): Promise<void> {
    return apiService.delete(`/teams/${teamId}/members/${userId}`);
  },

  async createInvitation(teamId: string, invitationData: any): Promise<any> {
    return apiService.post(`/teams/${teamId}/invitations`, invitationData);
  },

  async validateInvitation(inviteCode: string): Promise<any> {
    return apiService.get(`/teams/invite/${inviteCode}/validate`);
  },

  async joinTeam(inviteCode: string): Promise<any> {
    return apiService.post('/teams/join', { inviteCode });
  },

  async getPulse(teamId: string): Promise<any> {
    return apiService.get(`/teams/${teamId}/pulse`);
  },

  async getAnnouncements(teamId: string): Promise<any> {
    return apiService.get(`/teams/${teamId}/announcements`);
  },

  async createAnnouncement(teamId: string, announcementData: any): Promise<any> {
    return apiService.post(`/teams/${teamId}/announcements`, announcementData);
  },

  async getGoals(teamId: string): Promise<any> {
    return apiService.get(`/teams/${teamId}/goals`);
  },

  async createGoal(teamId: string, goalData: any): Promise<any> {
    return apiService.post(`/teams/${teamId}/goals`, goalData);
  },

  async getSettings(teamId: string): Promise<any> {
    return apiService.get(`/teams/${teamId}/settings`);
  },

  async updateSettings(teamId: string, settings: any): Promise<any> {
    return apiService.put(`/teams/${teamId}/settings`, settings);
  },

  async getMembersPulse(teamId: string): Promise<any> {
    return apiService.get(`/teams/${teamId}/members/pulse`);
  },

  async getStats(teamId: string, params?: any): Promise<any> {
    return apiService.get(`/teams/${teamId}/stats`, { params });
  },

  async getEvents(teamId: string): Promise<any> {
    return apiService.get(`/teams/${teamId}/events`);
  },

  async createEvent(teamId: string, eventData: any): Promise<any> {
    return apiService.post(`/teams/${teamId}/events`, eventData);
  },

  async getFeedback(teamId: string): Promise<any> {
    return apiService.get(`/teams/${teamId}/feedback`);
  },

  async submitFeedback(teamId: string, feedbackData: any): Promise<any> {
    return apiService.post(`/teams/${teamId}/feedback`, feedbackData);
  },

  async updateAnnouncement(teamId: string, announcementId: string, updates: any): Promise<any> {
    return apiService.put(`/teams/${teamId}/announcements/${announcementId}`, updates);
  },

  async deleteAnnouncement(teamId: string, announcementId: string): Promise<void> {
    return apiService.delete(`/teams/${teamId}/announcements/${announcementId}`);
  },

  async updateGoal(teamId: string, goalId: string, updates: any): Promise<any> {
    return apiService.put(`/teams/${teamId}/goals/${goalId}`, updates);
  },

  async deleteGoal(teamId: string, goalId: string): Promise<void> {
    return apiService.delete(`/teams/${teamId}/goals/${goalId}`);
  },

  async getUserTeams(userId?: string): Promise<any> {
    return apiService.get('/teams/user');
  },

  async sendReminders(teamId: string): Promise<void> {
    return apiService.post(`/teams/${teamId}/reminders`);
  },

  async sendNudge(data: { recipientId: string; message: string }): Promise<any> {
    return apiService.post('/nudges', data);
  },

  async getReceivedNudges(limit?: number): Promise<any> {
    return apiService.get('/nudges/received', { params: { limit } });
  },

  async getSentNudges(limit?: number): Promise<any> {
    return apiService.get('/nudges/sent', { params: { limit } });
  },
};
